export const COMMON = {
  START_LOADING: 'START_LOADING',
  END_LOADING: 'END_LOADING',
  GENERAL_SHOP_INFO: 'GENERAL_SHOP_INFO',
  SHOP_BANNED: 'SHOP_BANNED',
  SHOP_IS_OFFLINE: 'SHOP_IS_OFFLINE',
  SHOP_EXPIRED: 'SHOP_EXPIRED',
  SHOP_REDIRECTED: 'SHOP_REDIRECTED',
  SHOP_NOT_FOUND: 'SHOP_NOT_FOUND',
  CLEAR_SHOP_STATE: 'CLEAR_SHOP_STATE',
  CLEAR_PRODUCT: 'CLEAR_PRODUCT',
  SET_PERMISSION: 'SET_PERMISSION',
  IS_CUSTOM_DOMAIN: 'IS_CUSTOM_DOMAIN',
  IS_ADDITIONAL_DOMAIN: 'IS_ADDITIONAL_DOMAIN',
  GET_PRODUCT_BY_ID: 'GET_PRODUCT_BY_ID',
  PRODUCT_NOT_FOUND: 'PRODUCT_NOT_FOUND',
  GET_GROUP_BY_ID: 'GET_GROUP_BY_ID',
  GROUP_NOT_FOUND: 'GROUP_NOT_FOUND',
  GET_INVOICE_BY_ID: 'GET_INVOICE_BY_ID',
  GET_PAYMENT_LINK_BY_ID: 'GET_PAYMENT_LINK_BY_ID',
  SHOP_FEEDBACK: 'SHOP_FEEDBACK',
  REPORTS: 'REPORTS',
  ADD_BUNDLE: 'ADD_BUNDLE',
}

export const BANNER = {
  HEIGHT: 'HEIGHT',
}


export const DISCOVER = {
  PRODUCTS_INITIAL_LOAD: 'PRODUCTS_INITIAL_LOAD',
  PRODUCTS_LOAD: 'PRODUCTS_LOAD',
  PRODUCTS: 'PRODUCTS',
  CLEAR: 'CLEAR',
  CATEGORIES: 'CATEGORIES',
  MOBILE_FILTERS: 'MOBILE_FILTERS',
  MOBILE_SORT: 'MOBILE_SORT',
  TRENDING: 'TRENDING',

  INITIAL_FILTERS: 'INITIAL_FILTERS',

  FILTERS: {
    CATEGORY: 'CATEGORY',
    CATEGORY_ID: 'CATEGORY_ID',
    SHOP: 'SHOP',
    SHOP_ID: 'SHOP_ID',
    SORT: 'SORT',
    SEARCH: 'SEARCH',
    PRICE: 'PRICE',
    GATEWAY: 'GATEWAY',
    CURRENCY: 'CURRENCY',
    SCORE: 'SCORE',
    CLEAR: 'CLEAR',
    CREATED: 'CREATED',
  }
}


export const CART = {
  CLEAR: 'CLEAR_CART',
  REMOVE: 'REMOVE_FROM_CART',
  SET: 'SET_FROM_CART',
  UPDATE: 'UPDATE_CART',
  ADD: 'ADD_TO_CART',
  ADD_PURE: 'ADD_PURE_CART',
}


export const VARIANT = {
  SET: 'SET'
}

export const ADDON = {
  CLEAR: 'CLEAR_ADDON',
  REMOVE: 'REMOVE_ADDON',
  ADD: 'ADD_ADDON'
}

export const THEME = {
  SET_THEME: 'SET_THEME',
  SET_GLOBAL_THEME: 'SET_GLOBAL_THEME',
}

export const AUTH = {
  CUSTOMER_INFO: 'CUSTOMER_INFO',
  SIGNED_IN: 'SIGNED_IN',
  SIGNED_OUT: 'SIGNED_OUT',
  USER_DATA: 'USER_DATA',
  USER_NOTIFICATIONS: 'USER_NOTIFICATIONS',
  MARK_AS_READ: 'MARK_AS_READ',
  USER_SETTINGS: 'USER_SETTINGS',
  USER_SHOPS: 'USER_SHOPS',
}


export const ORDER = {
  ALL_ORDERS: 'ALL_ORDERS',
  LIVE_ORDER_DISPLAY: 'LIVE_ORDER_DISPLAY',
  ORDER: 'ORDER'
}

export const INVOICES = {
  INVOICES: 'INVOICES',
  INVOICE_BY_ID: 'INVOICE_BY_ID'
}

export const ANALYTICS = {
  ALL_REPORTS: 'ALL_REPORTS',
  NEW_REPORT: 'NEW_REPORT'
}

export const USERS = {
  USERS: 'USERS'
}

export const SHOPS = {
  SHOPS: 'SHOPS'
}

export const USER = {
  USER: 'USER',
  BAN: 'BAN',
  VALIDATE: 'VALIDATE',
  UNVALIDATE: 'UNVALIDATE',
}

export const SHOP = {
  SHOP: 'SHOP',
  BAN: 'BAN',
  VERIFY: 'VERIFY',
  UNVERIFY: 'UNVERIFY',
}

export const TOP_SHOPS = {
  TOP_SHOPS: 'TOP_SHOPS'
}

export const BLACKLIST = {
  BLACKLIST_LIST: 'BLACKLIST'
}

export const WHITELIST = {
  WHITELIST_LIST: 'WHITELIST'
}

export const WEBHOOK = {
  WEBHOOK_LIST: 'WEBHOOK_LIST',
  WEBHOOK_LOG_LIST: 'WEBHOOK_LOG_LIST'
}

export const TICKETS = {
  TICKETS_LIST: 'TICKETS'
}

export const NAV = {
  OPEN_NAV: 'OPEN_NAV',
  SUB_CATEGORY: 'SUB_CATEGORY',
  OPEN_MOBILE: 'OPEN_MOBILE'
}

export const PRODUCT = {
  PRODUCT_LIST: 'PRODUCT_LIST'
}

export const GROUP = {
  GROUP_LIST: 'GROUP_LIST'
}



export const COUPONS = {
  COUPONS: 'COUPONS_FETCH_SUCCESS',
  CURRENT_COUPON: 'CURRENT_COUPON'
}

export const FEEDBACKS = {
  FEEDBACKS: 'FEEDBACKS',
  CURRENT_FEEDBACK: 'CURRENT_FEEDBACK'
}

export const DASHBOARD = {
  BANK_ACCOUNT_TYPE: 'BANK_ACCOUNT_TYPE',
  BANK_ACCOUNT_GRAPH: 'BANK_ACCOUNT_GRAPH',
  CASH_FLOW_GRAPH: 'CASH_FLOW_GRAPH',
  INVOICE_GRAPH: 'INVOICE_GRAPH',
  PROFIT_LOSS: 'PROFIT_LOSS',
  EXPENSE_GRAPH: 'EXPENSE_GRAPH',
  REVENUE_GRAPH: 'REVENUE_GRAPH',
  TAXES: 'TAXES',
  WIDE_LAYOUT: 'WIDE_LAYOUT',
}

export const CONTACT = {
  CONTACT_LIST: 'CONTACT_LIST'
}


export const PAYMENT = {
  PAYMENT_LIST: 'PAYMENT_LIST'
}

export const CATEGORY = {
  ALL_CATEGORY: 'ALL_CATEGORY',
  CURRENT_CATEGORY: 'CURRENT_CATEGORY'
}

